import React, { FC, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

interface HourOnlyInputProps {
  label?: string;
  isRequired?: boolean;
  id: string;
  onChange?: (e: { target: { id: string; value: string } }) => void;
  value?: string;
  errorMsg?: string;
  hasError?: boolean;
  min?: string;
  hint?: string;
  showLabel?: boolean;
}

const HourOnlyInput: FC<HourOnlyInputProps> = ({
  label,
  isRequired,
  id,
  onChange,
  value,
  errorMsg,
  hasError,
  min,
  hint,
  showLabel = true,
}) => {
  const { formatMessage } = useIntl();
  const [selectedHour, setSelectedHour] = useState('00');
  const [selectedDate, setSelectedDate] = useState('');

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, '0')
  );

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        setSelectedDate(date.toISOString().split('T')[0]);
        setSelectedHour(String(date.getHours()).padStart(2, '0'));
      }
    }
  }, [value]);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    
    if (newDate && selectedHour) {
      const datetimeValue = `${newDate}T${selectedHour}:00:00`;
      onChange?.({ target: { id, value: datetimeValue } });
    }
  };

  const handleHourChange = (hour: string) => {
    setSelectedHour(hour);
    
    if (selectedDate && hour) {
      const datetimeValue = `${selectedDate}T${hour}:00:00`;
      onChange?.({ target: { id, value: datetimeValue } });
    }
  };

  return (
    <div>
      {label && showLabel && (
        <label className='form-label fw-bold fs-3'>
          {label} {isRequired && <sup className='text-danger'>*</sup>} 
          {hint && <small style={{fontSize: '12px'}} className='text-gray-600'>{hint}</small>}
        </label>
      )}
      
      <div className="d-flex gap-2">
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          className={`form-control ${hasError ? 'is-invalid' : ''}`}
          min={min}
        />
        
        <select
          value={selectedHour}
          onChange={(e) => handleHourChange(e.target.value)}
          className={`form-control ${hasError ? 'is-invalid' : ''}`}
          style={{ width: '100px' }}
        >
          {hours.map(hour => (
            <option key={hour} value={hour}>
              {hour}:00
            </option>
          ))}
        </select>
      </div>

      {isRequired && hasError && (
        <label style={{fontSize: '12px'}} className='form-label fw-bold text-danger'>
          {errorMsg ? errorMsg : formatMessage({ id: "required_field" })}
        </label>
      )}
    </div>
  );
};

export default HourOnlyInput;

